import type React from "react";
import { Link } from "react-router-dom";
import type { Goal } from "@/types/goal";
import { useProgress } from "@/hooks/useProgress";
import { useMemo } from "react";

interface GoalProgressBarProps {
	goal: Goal;
}

const GoalProgressBar: React.FC<GoalProgressBarProps> = ({ goal }) => {
	const { progress, loading, error } = useProgress(goal.id);

	const latestProgress = useMemo(() => {
		if (loading || error || !progress.length) return 0;
		return progress.sort(
			(a, b) =>
				new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
		)[0].progress;
	}, [progress, loading, error]);

	if (loading) return <div>読み込み中...</div>;
	if (error) return <div>エラーが発生しました</div>;

	return (
		<div className="mb-4">
			<div className="flex justify-between items-center mb-1">
				<Link
					to={`/webapp/goals/${goal.id}`}
					className="text-blue-500 hover:underline"
				>
					{goal.title}
				</Link>
				<span>{latestProgress}%</span>
			</div>
			<div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
				<div
					className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
					style={{ width: `${latestProgress}%` }}
				/>
			</div>
		</div>
	);
};

export default GoalProgressBar;
